import { useRoutes } from "react-router-dom";
import CreateCard from "../../Component/CreateCard.js"
import EditFormRoute from "../../Component/Forms/EditFormRoute.js"

import AddManageNetwork from "./ManageNetwork/Create.js"
import ManageNetwork from "./ManageNetwork/View.js"
import AddManageInstitute from "./ManageInstitute/Create.js"
import ManageInstitute from "./ManageInstitute/View.js"
import ProtectedRoute from "../RouteProtect.js"
import {checkRoutesAuth} from "../menu.js"
const CarrierCardArray = [
    {
        title: "Manage Network",
        path: "manageNetwork",
        auth: "carrier",
    },
    {
        title: "Manage Institute",
        path: "manageInstitute",
        auth: "carrier",
    },
]


const RoutesArray = [
    {
        path: "/",
        element: <CreateCard cardJson={[...CarrierCardArray]} />
    },
    {
        path: "*",
        element: <h1>This is 404</h1>
    },
    {
        path: "manageInstitute/*",
        element:
            (
                <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
                    <ManageInstitute />
                </ProtectedRoute>
            )
    },
    {
        path: "manageInstitute/:id",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
                <EditFormRoute />
            </ProtectedRoute>
        )
    },
    {
        path: "manageInstitute/addinstitute",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
                <AddManageInstitute />
            </ProtectedRoute>
        )
    },
    {
        path: "manageNetwork/*",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="amInformation" >
                <ManageNetwork />
            </ProtectedRoute>
        )
    },
    {
        path: "manageNetwork/:id",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="amInformation" >
                <EditFormRoute />
            </ProtectedRoute>
        )
    },
    {
        path: "manageNetwork/addnetwork",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="amInformation" >
                <AddManageNetwork />
            </ProtectedRoute>
        )
    },
];


export default function MangeRoutes() {
    return useRoutes(RoutesArray)
};